import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Navbar, Nav } from 'reactstrap';
import {
  isPatient,
  isAdmin,
  isRoleNameAdministrator,
} from 'utils/userTypeHelper';
import useUser from 'utils/useUser';
import { PLATFORM_CONFIG } from 'utils/accessManager/constants';
import NavbarDropdown from './navbarDropdown';
import NavbarProfileMenu from './navbarProfileMenu';

const HeaderNavbar = ({
  formsOptions,
  adminPanelOptions,
  practiceOptions,
  patientsOptions,
  profileOptions,
  firstName,
  lastName,
  title,
  disableNavigation,
}) => {
  const { userType, roleNames, platformMode } = useUser();

  return (
    <Navbar expand="md">
      <Link
        className="logo"
        data-cy="logged-in-logo"
        to={`${PLATFORM_CONFIG[platformMode].dashboard}`}
      />
      <Nav className="ml-auto" navbar>
        {!isPatient(userType) && !disableNavigation && (
          <>
            <NavbarDropdown
              label="Forms"
              dataCy="nav-forms"
              options={formsOptions}
            />
            {(isRoleNameAdministrator(roleNames) || isAdmin(userType)) &&
              !disableNavigation && (
                <NavbarDropdown
                  label="Admin panel"
                  dataCy="nav-admin"
                  options={adminPanelOptions}
                />
              )}
            {practiceOptions.length > 0 && !disableNavigation && (
              <NavbarDropdown
                label="Practice"
                dataCy="nav-practice"
                options={practiceOptions}
              />
            )}
            {patientsOptions.length > 0 && !disableNavigation && (
              <NavbarDropdown
                label="Patients"
                dataCy="nav-patients"
                options={patientsOptions}
              />
            )}
          </>
        )}
        <NavbarProfileMenu
          firstName={firstName}
          lastName={lastName}
          title={title}
          options={profileOptions}
          dataCy="nav-profile"
          limitedMenu={disableNavigation}
        />
      </Nav>
    </Navbar>
  );
};

HeaderNavbar.propTypes = {
  adminPanelOptions: PropTypes.arrayOf(PropTypes.shape()),
  practiceOptions: PropTypes.arrayOf(PropTypes.shape()),
  patientsOptions: PropTypes.arrayOf(PropTypes.shape()),
  profileOptions: PropTypes.arrayOf(PropTypes.shape()),
  formsOptions: PropTypes.arrayOf(PropTypes.shape()),
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  title: PropTypes.string,
  disableNavigation: PropTypes.bool,
};

export default HeaderNavbar;
